export class Archivo{
  idArchivo: number;
  nombre: string;
  comentario: string;
  tipo: string;
  fechaCarga: string;
  idUsuarioCarga: String;
  idFuente: BigInteger;
  rutaArchivo: string;
  contenido: string;
}
